import Vue from 'vue';
import Router from 'vue-router'
import {setSession} from "../filters/filters";

// PC
import Index from '@/views/pc/indexPage';   // 首页
import ExtensionPage from '@/views/pc/extensionPage';   // PC推广页
import ProdServH5 from '@/views/pc/prodServ_h5';   // 产品服务-h5+
import ProdServPc from '@/views/pc/prodServ_pc';   // 产品服务-pc
import SolutionNormal from '@/views/pc/solution_normal';   // 解决方案-通用方案
import SolutionProperty from '@/views/pc/solution_property';   // 解决方案-地产行业
import SolutionTimelyDist from '@/views/pc/solution_timelyDist';   // 解决方案-及时配送行业
import AboutUser from '@/views/pc/aboutUser'; //关于我们
import NewsAndInfo from '@/views/pc/newsAndInfo'; //资讯
import NewsAndInfoDetail from '@/views/pc/newsAndInfoDetail'; //资讯详情
import JobRecruit from '@/views/pc/jobRecruit'; //招聘求职
import JobPost from '@/views/pc/jobPost'; //发布求职
import RegisterAgree from '@/views/pc/registerAgree'; //个人信息保护政策
import PrivacyPolicy from '@/views/pc/privacyPolicy'; //用户协议及隐私政策
import jobRecruitDetail from '@/views/pc/jobRecruitDetail'; //职位详情


// Mobile
import MIndex from '@/views/mobile/mIndexPage' // 移动端首页
import MIndexPage from '@/views/mobile/mIndexOfficialPage' // 公众号进来的立即预约页面
import MExtensionPage from '@/views/mobile/mExtensionPage' // 移动端官网专题推广页
import mAboutUser from '@/views/mobile/mAboutUser' //移动端关于我们
import mNewsAndInfo from '@/views/mobile/mNewsAndInfo' //移动端资讯
import mNewsAndInfoDetail from '@/views/mobile/mNewsAndInfoDetail' //移动端资讯详情
import mProdServH5 from '@/views/mobile/mProdServ_h5' //移动端产品服务-h5+
import mProdServPc from '@/views/mobile/mProdServ_pc' //移动端产品服务-pc
import mSolutionNormal from '@/views/mobile/mSolution_normal' //移动端解决方案-通用方案
import mSolutionProperty from '@/views/mobile/mSolution_property' //移动端解决方案-地产行业
import mSolutionTimelyDist from '@/views/mobile/mSolution_timelyDist';   // 移动端解决方案-及时配送行业
import mContactUs from '@/views/mobile/mContactUs_aboutUser';   // 移动端关于我们 - 联系我们
import mKnowUs from '@/views/mobile/mKnowUs_aboutUser';   // 移动端关于我们 - 了解我们
import mJoinUs from '@/views/mobile/mJoinUs_aboutUser';   // 移动端关于我们 - 加入我们

Vue.use(Router)

export default new Router({
  routes: [
    //PC官网start
    {
      path: '/',
      // TODO: 备案打开这里 --- ljl

      // redirect: to => {
      //   var whichAddress = window.location.hostname;
      //   var hyRouter = [
      //     'www.hyhvyogo.com','hyhvyogo.com','b.hyhvyogo.com',
      //     'www.hnhvyogo.com','hnhvyogo.com','b.hnhvyogo.com',
      //     'localhost'
      //   ];
      //   if(hyRouter.includes(whichAddress)){
      //     setSession('menuName','招聘求职');
      //     setSession('menuSonName', '社会招聘')
      //     return '/jobRecruit'
      //   }else{
      //     return '/index'
      //   }
      // },
      
      redirect: '/index', 
    },  
    {
      path: '/index',
      name: 'index-page',
      component: Index,
      meta:{
        title:"慧用工智能结算系统"
      },
      
    },
    {
      path: '/extensionPage',
      name: 'extension-page',
      component: ExtensionPage,
      meta:{
        title:"慧用工智能结算系统"
      },
      
    },


    {
      path: '/prodServH5',
      name: 'prod-serv-h5',
      component: ProdServH5,
      meta:{
        title:"慧用工智能结算系统"
      }
    },
    {
      path: '/prodServPc',
      name: 'prod-serv-pc',
      component: ProdServPc,
      meta:{
        title:"慧用工智能结算系统"
      }
    },
    {
      path: '/solutionNormal',
      name: 'solution-normal',
      component: SolutionNormal,
      meta:{
        title:"慧用工智能结算系统"
      }
    },
    {
      path: '/solutionProperty',
      name: 'solution-property',
      component: SolutionProperty,
      meta:{
        title:"慧用工智能结算系统"
      }
    },
    {
      path: '/solutionTimelyDist',
      name: 'solution-timely-dist',
      component: SolutionTimelyDist,
      meta:{
        title:"慧用工智能结算系统"
      }
    },

    {
      path: '/aboutUser',
      name: 'about-user',
      component: AboutUser,
      meta: {
        title: '关于我们'
      }
    },

    {
      path: '/newsAndInfo',
      name: 'new-and-info',
      component: NewsAndInfo,
      meta: {
        title: '慧用工智能结算系统'
      }
    },
    
    {
      path: '/newsAndInfoDetail',
      name: 'news-and-info-detail',
      component: NewsAndInfoDetail,
      meta: {
        title: '慧用工智能结算系统'
      }
    },

    {
      path: '/jobRecruit',
      name: 'job-recruit',
      component: JobRecruit,
      meta: {
        title: '慧用工智能结算系统'
      }
    },

    {
      path: '/jobPost',
      name: 'job-post',
      component: JobPost,
      meta: {
        title: '慧用工智能结算系统'
      }
    },

    {
      path: '/registerAgree',
      name: 'register-agree',
      component: RegisterAgree,
      meta: {
        title: '慧用工智能结算系统'
      }
    },

    {
      path: '/privacyPolicy',
      name: 'privacy-policy',
      component: PrivacyPolicy,
      meta: {
        title: '慧用工智能结算系统'
      }
    },
    {
      path: '/jobRecruitDetail',
      name: 'job-recruit-detail',
      component: jobRecruitDetail,
      meta: {
        title: '慧用工智能结算系统'
      }
    },
    
    //PC官网end

    //MOBILE官网start
    {
      path: '/mIndex',
      name: 'mIndex-Page',
      component: MIndex,
      meta:{
        title:"慧用工智能结算系统"
      }
    },
    {
      path: '/mIndexPage',
      name: 'mIndex-official-page',
      component: MIndexPage,
      meta:{
        title:"慧用工智能结算系统"
      }
    },
    //推广页 
    {
      path: '/mExtensionPage',
      name: 'mExtension-page',
      component: MExtensionPage,
      meta:{
        title:"慧用工智能结算系统"
      }
    },
    {
      path: '/mAboutUser',
      name: 'mAbout-user',
      component: mAboutUser,
      meta:{
        title:"慧用工智能结算系统"
      },
      children: [
        {
          path: '/mContactUs',
          name: 'mContact-us',
          component: mContactUs,
          meta:{
            title:"慧用工智能结算系统"
          }
        },
        {
          path: '/mKnowUs',
          name: 'mKnow-us',
          component: mKnowUs,
          meta:{
            title:"慧用工智能结算系统"
          }
        },
        {
          path: '/mJoinUs',
          name: 'mJoin-us',
          component: mJoinUs,
          meta:{
            title:"慧用工智能结算系统"
          }
        },
      ]
    },
    {
      path: '/mNewsAndInfo',
      name: 'mNews-and-info',
      component: mNewsAndInfo,
      meta:{
        title:"慧用工智能结算系统"
      }
    },
    {
      path: '/mNewsAndInfoDetail',
      name: 'mNews-and-info-detail',
      component: mNewsAndInfoDetail,
      meta:{
        title:"慧用工智能结算系统"
      }
    },
    {
      path: '/mProdServH5',
      name: 'mProd-serv-h5',
      component: mProdServH5,
      meta:{
        title:"慧用工智能结算系统"
      }
    },
    {
      path: '/mProdServPc',
      name: 'mProd-serv-pc',
      component: mProdServPc,
      meta:{
        title:"慧用工智能结算系统"
      }
    },
    {
      path: '/mSolutionNormal',
      name: 'mSolution-normal',
      component: mSolutionNormal,
      meta:{
        title:"慧用工智能结算系统"
      }
    },
    {
      path: '/mSolutionTimelyDist',
      name: 'mSolution-timely-dist',
      component: mSolutionTimelyDist,
      meta:{
        title:"慧用工智能结算系统"
      }
    },
    {
      path: '/mSolutionProperty',
      name: 'mSolution-property',
      component: mSolutionProperty,
      meta:{
        title:"慧用工智能结算系统"
      }
    },

    //MOBILE官网end
  ],

  //解决页面跳转后路由不置顶
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js